import type { CertGenParams } from '@yandex-int/k-common';

interface OlympParams extends CertGenParams {
    subject: string;
}

export const GLSpring2022 = ({
    school_name: schoolName,
    first_name: firstName,
    middle_name: middleName,
    last_name: lastName,
    subject,
}: OlympParams) => {
    let backgroundSrc, color, olympLogo, olympName;

    switch (subject) {
        case 'GLMathSpring2022':
            backgroundSrc = 'https://e7n.s3.yandex.net/static/education/olymp2022/letters/math.png';
            olympLogo = 'https://e7n.s3.yandex.net/static/education/olymp2022/letters/math-logo.svg';
            color = '#D1FFF4';
            olympName = 'Я люблю математику';
            break;
        case 'GLRusSpring2022':
            backgroundSrc = 'https://e7n.s3.yandex.net/static/education/olymp2022/letters/rus.png';
            olympLogo = 'https://e7n.s3.yandex.net/static/education/olymp2022/letters/rus-logo.svg';
            color = '#FFDBE8';
            olympName = 'Я люблю русский язык';
            break;
        case 'GLNatureSpring2022':
            backgroundSrc = 'https://e7n.s3.yandex.net/static/education/olymp2022/letters/nature.png';
            olympLogo = 'https://e7n.s3.yandex.net/static/education/olymp2022/letters/nature-logo.svg';
            color = '#FFF7CC';
            olympName = 'Я люблю окружающий мир';
            break;
        default:
            backgroundSrc = 'unset';
            olympLogo = 'unset';
            color = 'unset';
            olympName = '';
            break;
    }

    return `
        <!DOCTYPE html>
        <html>
            <head>
                <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                <style>
                    @font-face {
                        font-family: "YS Text";
                        src: url("https://yastatic.net/s3/home/fonts/ys/1/text-light.woff2")
                                format("woff2"),
                            url("https://yastatic.net/s3/home/fonts/ys/1/text-light.woff")
                                format("woff");
                        font-weight: 300;
                        font-style: normal;
                    }

                    @font-face {
                        font-family: "YS Text";
                        src: url("https://yastatic.net/s3/home/fonts/ys/1/text-regular.woff2")
                                format("woff2"),
                            url("https://yastatic.net/s3/home/fonts/ys/1/text-regular.woff")
                                format("woff");
                        font-weight: 400;
                        font-style: normal;
                    }

                    @font-face {
                        font-family: "YS Text";
                        src: url("https://yastatic.net/s3/home/fonts/ys/1/text-medium.woff2")
                                format("woff2"),
                            url("https://yastatic.net/s3/home/fonts/ys/1/text-medium.woff")
                                format("woff");
                        font-weight: 500;
                        font-style: normal;
                    }

                    @font-face {
                        font-family: "YS Text";
                        src: url("https://yastatic.net/s3/home/fonts/ys/1/text-bold.woff2")
                                format("woff2"),
                            url("https://yastatic.net/s3/home/fonts/ys/1/text-bold.woff")
                                format("woff");
                        font-weight: bold;
                        font-style: normal;
                    }

                    @page {
                        size: 210mm 297mm;
                        margin: 0;
                    }

                    @media print {
                        html,
                        body {
                            height: 297mm;
                            width: 210mm;
                        }
                    }

                    html {
                        position: relative;

                        margin: 0;
                        padding: 0;
                    }

                    body {
                        margin: 0;

                        color: #000;

                        font-family: "YS Text";
                    }

                    .page {
                        position: relative;

                        overflow: hidden;

                        box-sizing: border-box;

                        width: 210mm;
                        height: 297mm;

                        background: #fff;

                        page-break-after: always;
                    }

                    .page-background {
                        position: absolute;

                        z-index: 1;

                        width: 100%;
                        height: 100%;

                        background-image: url("${backgroundSrc}");
                        background-repeat: no-repeat;
                        background-position: bottom;

                        background-size: contain;
                    }

                    .page-content {
                        display: grid;
                        grid-template-columns:
                            calc(404mm * 210 / 638)
                            calc(234mm * 210 / 638);

                        height: 100%;
                    }

                    .letter-info {
                        padding-top: calc(39mm * 210 / 638);
                        padding-right: calc(48mm * 210 / 638);
                        padding-left: calc(39mm * 210 / 638);

                        z-index: 2;
                    }

                    .olymp-logo {
                        height: calc(64mm * 210 / 638);
                        margin-bottom: calc(41mm * 210 / 638);
                    }

                    .thank-you-letter {
                        margin-bottom: calc(25mm * 210 / 638);

                        font-size: calc(32mm * 210 / 638);
                        line-height: calc(38mm * 210 / 638);
                    }

                    .teacher-data {
                        margin-bottom: calc(12mm * 210 / 638);

                        font-size: calc(27mm * 210 / 638);
                        line-height: calc(32mm * 210 / 638);
                    }

                    .school-name {
                        margin-bottom: calc(36mm * 210 / 638);

                        font-size: calc(12mm * 210 / 638);
                        line-height: calc(16mm * 210 / 638);
                    }

                    .description {
                        font-size: calc(14mm * 210 / 638);
                        line-height: calc(22mm * 210 / 638);
                    }

                    .date {
                        position: absolute;
                        top: calc(10mm * 210 / 638);
                        left: calc(-45mm * 210 / 638);

                        transform: rotate(180deg);
                        white-space: nowrap;
                        text-transform: uppercase;

                        color: ${color};

                        font-size: calc(48mm * 210 / 638);
                        font-weight: bold;
                        line-height: calc(58mm * 210 / 638);
                        writing-mode: vertical-lr;
                    }

                    .service-info {
                        position: relative;

                        padding-top: calc(39mm * 210 / 638);
                        padding-left: calc(30mm * 210 / 638);

                        background-color: ${color};
                    }

                    .service-info__book-logo {
                        width: calc(164mm * 210 / 638);
                        height: calc(20mm * 210 / 638);
                        margin-bottom: calc(24mm * 210 / 638);
                    }

                    .service-info__cpm-logo {
                        width: calc(116mm * 210 / 638);
                        height: calc(36mm * 210 / 638);
                        margin-bottom: calc(63mm * 210 / 638);
                    }

                    .place {
                        margin-bottom: calc(37mm * 210 / 638);

                        font-size: calc(12mm * 210 / 638);
                        line-height: calc(16mm * 210 / 638);
                    }

                    .signature__marker {
                        margin-bottom: calc(8mm * 210 / 638);
                    }

                    .signature__marker_moskvichev {
                        width: calc(56mm * 210 / 638);
                        height: calc(84mm * 210 / 638);
                    }

                    .signature__marker_yashenko {
                        width: calc(51mm * 210 / 638);
                        height: calc(45mm * 210 / 638);
                    }

                    .signature__name {
                        margin-bottom: calc(8mm * 210 / 638);

                        font-size: calc(13mm * 210 / 638);
                        line-height: calc(15mm * 210 / 638);
                    }

                    .signature__info {
                        margin-bottom: calc(18mm * 210 / 638);

                        font-size: calc(10mm * 210 / 638);
                        line-height: calc(14mm * 210 / 638);
                    }
                </style>
            </head>
            <body>
                <div class="page">
                    <div class="page-background"></div>

                    <div class="page-content">
                        <div class="letter-info">
                            <img
                                src="${olympLogo}"
                                alt="olymp-logo"
                                class="olymp-logo"
                            />

                            <div class="thank-you-letter">
                                Благодарственное
                                <br />
                                письмо
                            </div>
                            <div class="teacher-data">
                                <div>${firstName}</div>
                                <div>${middleName}</div>
                                <div>${lastName}</div>
                            </div>

                            <div class="school-name">${schoolName}</div>

                            <div class="description">
                                Уважаемый учитель!<br />
                                Благодарим Вас за вклад в развитие<br />
                                олимпиадного движения и участие<br />
                                Ваших учеников в олимпиаде<br />
                                «${olympName}» для 1–4 классов.
                            </div>
                        </div>

                        <div class="service-info">
                            <div class="date">Весна 2022</div>

                            <img
                                src="https://e7n.s3.yandex.net/static/education/olymps/logo.png"
                                alt="book-logo"
                                class="service-info__book-logo"
                            />
                            <img
                                src="https://e7n.s3.yandex.net/static/education/olymp2022/letters/cpm-logo.png"
                                alt="cpm-logo"
                                class="service-info__cpm-logo"
                            />

                            <div class="place">Москва, 2022</div>

                            <div class="signature">
                                <img
                                    src="https://e7n.s3.yandex.net/static/education/olymp2022/letters/moskvichev-sign.svg"
                                    alt="moskvichev-sign"
                                    class="signature__marker signature__marker_moskvichev"
                                />
                                <div class="signature__descr">
                                    <div class="signature__name">А. М. Москвичев</div>
                                    <div class="signature__info">
                                        Руководитель сервиса<br />
                                        Яндекс Учебник
                                    </div>
                                </div>
                            </div>
                            <div class="signature">
                                <img
                                    src="https://e7n.s3.yandex.net/static/education/olymp2022/letters/yashenko-sign.svg"
                                    alt="yashenko-sign"
                                    class="signature__marker signature__marker_yashenko"
                                />
                                <div class="signature__descr">
                                    <div class="signature__name">И. В. Ященко</div>
                                    <div class="signature__info">
                                        Председатель оргкомитета<br />
                                        олимпиады, директор Центра<br />
                                        педагогического мастерства
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </body>
        </html>
    `;
};
